import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

// GET /api/SettingsPaymentType/MasterGet
export function* masterGetPaymentType(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        APIS.SETTINGS_PAYMENT_TYPE.MASTER_GET,
        action.payload,
        true
    );
}

// GET /api/SettingsPaymentType/Get
export function* getPaymentType(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        APIS.SETTINGS_PAYMENT_TYPE.GET,
        action.payload,
        true
    );
}

// POST /api/SettingsPaymentType/InsertUpdate
export function* insertUpdatePaymentType(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.SETTINGS_PAYMENT_TYPE.INSERT_UPDATE,
        action.payload,
        true
    );
}

// GET /api/SettingsPaymentType/DetailsById
export function* detailsByIdPaymentType(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        APIS.SETTINGS_PAYMENT_TYPE.DETAILS_BY_ID,
        action.payload,
        true
    );
}

// POST /api/SettingsPaymentType/Delete
export function* deletePaymentType(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.SETTINGS_PAYMENT_TYPE.DELETE + `?id=${action.payload.id}`,
        action.payload,
        true
    );
}

// POST /api/SettingsPaymentType/StatusChange
export function* statusChangePaymentType(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.SETTINGS_PAYMENT_TYPE.STATUS_CHANGE,
        action.payload,
        true
    );
}